export default function() {
  const sendButton = document.querySelector('#works-list-judging-change');

  if (!sendButton) {
    return;
  }

  const worksListForm = document.querySelector('#works-list-judging-form');

  if (!worksListForm) {
    return;
  }

  sendButton?.addEventListener('click', function (e) {
    e.preventDefault();

    const checkedItems = document.querySelectorAll('input[name="checked_items[]"]:checked');

    if (!checkedItems) {
      return;
    }

    checkedItems.forEach(function (item) {
      const workItemInput = document.createElement('input');
      workItemInput.setAttribute('type', 'hidden');
      workItemInput.setAttribute('name', 'checked_items[]');
      workItemInput.setAttribute('value', item.value);

      worksListForm.appendChild(workItemInput);
    });

    worksListForm.submit();
  });
}